import React from 'react';

export default function CardPersonale({ member, idx }) {
  return (
    <div key={`img_${idx}`} id={`card_${idx}`}>
      <div className="h-auto overflow-hidden rounded-3xl">
        {member.foto ? (
          <img
            src={member.foto}
            alt={member.nome_completo}
            className="w-full"
          />
        ) : (
          <div className="w-full bg-gray-700 aspect-square"></div>
        )}
      </div>
      <p className="mt-3 font-bold text-white">{member.nome}</p>
      <p className="text-white ">{member.ruolo_it}</p>
    </div>
  );
}
